import { Companion_instance1nnj4w3jsr8ee as Companion_instance } from '../../../../../testmints-action-async/com/zegreatrob/testmints/action/ActionPipe.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Builder3lcn00uc5gcy3 as Builder } from '../../../../../apollo-kotlin-apollo-runtime/com/apollographql/apollo/ApolloClient.mjs';
import { ktorClient27akr7bvktwel as ktorClient } from '../../../../../apollo-kotlin-ktor-support-apollo-engine-ktor/com/apollographql/ktor/KtorExtensions.mjs';
import { DispatcherPipeCannon3aitdk4bdtfxf as DispatcherPipeCannon } from '../../../../../testmints-action-async/com/zegreatrob/testmints/action/ActionCannon.mjs';
import {
  perform1lpz4lrok8gc1 as perform,
  SdkBoost3eue7fgosgz0d as SdkBoost,
} from './SdkBoost.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  perform229jxw4jfq0sa as perform_0,
  SdkCreateSecretCommandDispatcher1ii7hep4t7p2 as SdkCreateSecretCommandDispatcher,
} from './SdkCreateSecretCommandDispatcher.mjs';
import {
  perform2289fmh0idzb8 as perform_1,
  SdkDeletePairAssignmentsCommandDispatcher3r89xhj6g83sl as SdkDeletePairAssignmentsCommandDispatcher,
} from './SdkDeletePairAssignmentsCommandDispatcher.mjs';
import {
  perform2t9ybhxlm395j as perform_2,
  SdkDeletePartyCommandDispatcher27loij2ye5nr9 as SdkDeletePartyCommandDispatcher,
} from './SdkDeletePartyCommandDispatcher.mjs';
import {
  performns8rzgu34czv as perform_3,
  SdkDeletePinCommandDispatcher31mrzwlipmcuz as SdkDeletePinCommandDispatcher,
} from './SdkDeletePinCommandDispatcher.mjs';
import {
  perform1ikoxhjpdkc2c as perform_4,
  SdkDeletePlayerCommandDispatcher2rxhmptx7gljw as SdkDeletePlayerCommandDispatcher,
} from './SdkDeletePlayerCommandDispatcher.mjs';
import {
  perform3fglo63zx58sn as perform_5,
  SdkDeleteSecretCommandDispatcher1wzqb0vkuors as SdkDeleteSecretCommandDispatcher,
} from './SdkDeleteSecretCommandDispatcher.mjs';
import {
  perform2rdkv3ij8pjwv as perform_6,
  SdkGrantDiscordAccessjjorbkvtrfx9 as SdkGrantDiscordAccess,
} from './SdkGrantDiscordAccess.mjs';
import {
  perform8stx2d3k0qmh as perform_7,
  SdkGrantSlackAccess15ga4e1z55nsr as SdkGrantSlackAccess,
} from './SdkGrantSlackAccess.mjs';
import {
  perform1ra73mflv67e8 as perform_8,
  SdkGraphQueryDispatcher2qog4v6gbj5of as SdkGraphQueryDispatcher,
} from './SdkGraphQueryDispatcher.mjs';
import {
  perform15g9rehua23fy as perform_9,
  SdkSavePairAssignmentsCommandDispatcher3ocpuomh8jp9i as SdkSavePairAssignmentsCommandDispatcher,
} from './SdkPairAssignmentDocumentSave.mjs';
import {
  perform14gugfzohs1yo as perform_10,
  SdkSavePartyCommandDispatcher1x5cidvmu3vb0 as SdkSavePartyCommandDispatcher,
} from './SdkSavePartyCommandDispatcher.mjs';
import {
  perform4djm8y8w4kmm as perform_11,
  SdkSavePinCommandDispatcher1w2xmq7bhdmfl as SdkSavePinCommandDispatcher,
} from './SdkSavePinCommandDispatcher.mjs';
import {
  perform29ufjcxl0l3il as perform_12,
  SdkSavePlayerCommandDispatcher2k2b5uhezxdlq as SdkSavePlayerCommandDispatcher,
} from './SdkSavePlayerCommandDispatcher.mjs';
import {
  performq4a2arsdobnz as perform_13,
  SdkSaveSlackIntegrationCommandDispatcher1t7cxnysmjc4h as SdkSaveSlackIntegrationCommandDispatcher,
} from './SdkSaveSlackIntegrationCommandDispatcher.mjs';
import {
  perform2mk8us9ba1bnq as perform_14,
  SdkSpin3glo2r2cb0vqe as SdkSpin,
} from './SdkSpin.mjs';
import {
  execute3h5s1lxc3f5yu as execute,
  GqlTrait2wtoeyl3yfalb as GqlTrait,
} from './gql/GqlTrait.mjs';
import { Dispatchernmy2not8m2c7 as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/SavePairAssignmentsCommand.mjs';
import { Dispatcher1dgi8c7arrsv1 as Dispatcher_0 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/DeletePlayerCommand.mjs';
import { Dispatcher27uwezb7p8fpg as Dispatcher_1 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantDiscordAccessCommand.mjs';
import { Dispatcher3ngwv5mtnm33a as Dispatcher_2 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/ApplyBoostCommand.mjs';
import { Dispatchervu4hb3oerxrm as Dispatcher_3 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantSlackAccessCommand.mjs';
import { Dispatcher3r3trxa1ofgr6 as Dispatcher_4 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/DeleteSecretCommand.mjs';
import { Dispatcher2txct93ff9b99 as Dispatcher_5 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/DeletePinCommand.mjs';
import { Dispatcher39hthxqv8voqz as Dispatcher_6 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/SavePlayerCommand.mjs';
import { Dispatcherb76d0p5pxiow as Dispatcher_7 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/SavePinCommand.mjs';
import { Dispatcher2jh9je6zwmtr7 as Dispatcher_8 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/DeletePartyCommand.mjs';
import { Dispatcher3f3rv68jjbf7x as Dispatcher_9 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/CreateSecretCommand.mjs';
import { Dispatchernurlbopdkn3a as Dispatcher_10 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/SpinCommand.mjs';
import { Dispatcher3kdydho2ojhnk as Dispatcher_11 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SaveSlackIntegrationCommand.mjs';
import { Dispatcher396y2mcz9r128 as Dispatcher_12 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SavePartyCommand.mjs';
import { Dispatcher2k7js8ct0qtp5 as Dispatcher_13 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/DeletePairAssignmentsCommand.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  apolloMutation39d5uh404zg7i as apolloMutation,
  apolloQuery3uw4osqu5xxua as apolloQuery,
  KtorQueryPerformer3enpohylr2sy5 as KtorQueryPerformer,
} from './gql/KtorQueryPerformer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function couplingSdk(getIdTokenFunc, httpClient, pipe) {
  pipe = pipe === VOID ? Companion_instance : pipe;
  return new (DispatcherPipeCannon())(new (KtorCouplingSdkDispatcher())(getIdTokenFunc, httpClient, ktorClient((new (Builder())()).k60('/api/graphql'), httpClient).i37()), pipe);
}
var KtorCouplingSdkDispatcherClass;
function KtorCouplingSdkDispatcher() {
  if (KtorCouplingSdkDispatcherClass === VOID) {
    class $ {
      constructor(getIdTokenFunc, httpClient, apolloClient) {
        this.j6t_1 = getIdTokenFunc;
        this.k6t_1 = new (StandardPartyGQLPerformer())(this.j6t_1, httpClient, apolloClient);
      }
      l6t() {
        return this.k6t_1;
      }
      q2g(command, $completion) {
        return this.m6t(command, $completion);
      }
      o2h(command, $completion) {
        return this.o6t(command, $completion);
      }
      d2i(command, $completion) {
        return this.p6t(command, $completion);
      }
      j2i(command, $completion) {
        return this.q6t(command, $completion);
      }
    }
    protoOf($).m6t = perform;
    protoOf($).m2i = perform_0;
    protoOf($).i2h = perform_1;
    protoOf($).r2h = perform_2;
    protoOf($).a2i = perform_3;
    protoOf($).g2i = perform_4;
    protoOf($).p2i = perform_5;
    protoOf($).t2g = perform_6;
    protoOf($).w2g = perform_7;
    protoOf($).n6t = perform_8;
    protoOf($).o6t = perform_9;
    protoOf($).u2h = perform_10;
    protoOf($).p6t = perform_11;
    protoOf($).q6t = perform_12;
    protoOf($).x2h = perform_13;
    protoOf($).z2g = perform_14;
    protoOf($).r6t = execute;
    initMetadataForClass($, 'KtorCouplingSdkDispatcher', VOID, VOID, [Dispatcher(), Dispatcher_0(), Dispatcher_1(), Dispatcher_2(), Dispatcher_3(), Dispatcher_4(), Dispatcher_5(), Dispatcher_6(), Dispatcher_7(), Dispatcher_8(), Dispatcher_9(), Dispatcher_10(), Dispatcher_11(), Dispatcher_12(), Dispatcher_13(), SdkBoost(), GqlTrait(), SdkCreateSecretCommandDispatcher(), SdkDeletePairAssignmentsCommandDispatcher(), SdkDeletePartyCommandDispatcher(), SdkDeletePinCommandDispatcher(), SdkDeletePlayerCommandDispatcher(), SdkDeleteSecretCommandDispatcher(), SdkGrantDiscordAccess(), SdkGrantSlackAccess(), SdkGraphQueryDispatcher(), SdkSavePairAssignmentsCommandDispatcher(), SdkSavePartyCommandDispatcher(), SdkSavePinCommandDispatcher(), SdkSavePlayerCommandDispatcher(), SdkSaveSlackIntegrationCommandDispatcher(), SdkSpin()], [1]);
    KtorCouplingSdkDispatcherClass = $;
  }
  return KtorCouplingSdkDispatcherClass;
}
var StandardPartyGQLPerformerClass;
function StandardPartyGQLPerformer() {
  if (StandardPartyGQLPerformerClass === VOID) {
    class $ {
      constructor(getIdTokenFunc, httpClient, apolloClient) {
        this.s6t_1 = getIdTokenFunc;
        this.t6t_1 = apolloClient;
        this.u6t_1 = httpClient;
      }
      v6t() {
        return this.t6t_1;
      }
      *w6t($completion) {
        return yield* this.s6t_1($completion);
      }
    }
    protoOf($).x6t = apolloMutation;
    protoOf($).y6t = apolloQuery;
    initMetadataForClass($, 'StandardPartyGQLPerformer', VOID, VOID, [KtorQueryPerformer()], [0, 1]);
    StandardPartyGQLPerformerClass = $;
  }
  return StandardPartyGQLPerformerClass;
}
//region block: exports
export {
  couplingSdk as couplingSdk1kvwqabhypuft,
};
//endregion

//# sourceMappingURL=KtorSdk.mjs.map
